module.exports = __webpack_public_path__ + "static/img/s02.207df3a7.png";